import { EventEmitter } from 'events';

const Bus = new EventEmitter();

Bus.setMaxListeners(1);

export default Bus;
